import { render, staticRenderFns } from "./OrderItemGroup.vue?vue&type=template&id=6f779b35"
import script from "./OrderItemGroup.vue?vue&type=script&lang=js"
export * from "./OrderItemGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports